import { AuthContext, type AuthContextProps } from "@/auth/context.tsx";
import { useContext } from "react";

export const useAuth = (): Exclude<AuthContextProps, "loading" | "unauthenticated"> => {
  const context = useContext(AuthContext);
  if (context === "loading" || context === "unauthenticated") {
    throw new Error("useAuth is called outside of a protected route");
  }
  return context;
};

export const logout = () => {
  localStorage.removeItem("token");
  window.location.reload();
};
